import { useMemo, useState } from "react"
import { useHistory, useRouteMatch } from "react-router"
import transactionService from "../../../axios/services/transactionService"
import Table from "../../../components/Table"
import MainButton from "../../../components/templates/MainButton"
import SimpleCard from "../../../components/templates/SimpleCard"
import toIDR from "../../../utils/helpers/toIDR"
import styles from './transactionDetail.module.scss'
import { OrderStatusTypes } from "../../../utils/enums/orderStatusTypes"
import stylese from '../../CreateTransaction/createTransaction.module.scss'

const DetailSuccess = ({
  setStep,
  setCompletedOne,
  items,
  loading
}) => {
  const { params: { code, id } } = useRouteMatch();
  const { push } = useHistory()
  const [canceling, setCanceling] = useState(false)
  const initialValue = 0;
  const fee = items.reduce(
    (accumulator, currentValue) => accumulator + currentValue.fee,
    initialValue
  );
  const totalNominal = items.reduce(
    (accumulator, currentValue) => accumulator + currentValue.amount,
    initialValue
  );
  const total = items.reduce(
    (accumulator, currentValue) => accumulator + (currentValue.amount+currentValue.fee),
    initialValue
  );
  console.log(items, fee)
  
  const onContinue = () => {
    setStep(2)
    setCompletedOne(true)
  }

  const onCancel = () => {
    setCanceling(true)
    transactionService.cancel(id)
      .then(() => push('/transaction'))
      .finally(() => setCanceling(false))
  }

  const columns = useMemo(() => ([
    {
      title: 'Bank', key: 'bank'
    },
    {
      title: 'No Rekening', key: 'bankAccount'
    },
    {
      title: 'Nama', key: 'fullName'
    },
    // {
    //   title: 'NAMA DI SISTEM BANK', key: 'bankAccountName'
    // },
    {
      title: 'Nominal (Rp)', key: 'amount', render: v => (<>Rp.{toIDR(v ?? 0, false)}</>)
    },
    {
      title: 'Biaya (Rp)', key: 'fee', render: v => (<>Rp.{toIDR(v ?? 0, false)}</>)
    },
    {
      title: 'Email', key: 'email'
    },
    {
      title: 'Berita', key: 'description'
    },
    {
      title: 'Status', key: 'status', render: (e) => OrderStatusTypes.getStr(e)
    },
  ]), [])

  return (
    <>
      <div className="mb-24">
        <h5 className="font-size-16 text-dark-gray font-500">ID Transaksi: {code}</h5>
      </div>
      <div>
        <SimpleCard loading={canceling}  className={stylese.confirmation}>
          <Table
            data={items}
            config={{
              columns,
              withIndex: true,
              pagination: false,
              loading: loading
            }}
          />
          <div className={stylese.total}>
            <table>
              <tbody>
                <tr>
                  <td>Total Biaya Transfer</td>
                  <td>{toIDR(fee)}</td>
                </tr>
                <tr>
                  <td>Total Nominal</td>
                  <td>{toIDR(totalNominal)}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>{toIDR(total)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </SimpleCard>
      </div>
    </>
  )
}

export default DetailSuccess
